import React from 'react';
import './terms.css';

const TermsPage = () => {
  return (
    <div className="terms-page">
      <h1 className="terms-title">Terms of Use</h1>
      <div className="terms-content">
        <h2>1. Introduction</h2>
        <p>
          Welcome to our 3D room design website. These terms of use govern your use of the website, so please read them carefully before accessing or using the services.
        </p>

        <h2>2. Acceptance of Terms</h2>
        <p>
          By accessing or using our website, you agree to be bound by these terms of use. If you do not agree to these terms, please refrain from using the website.
        </p>

        <h2>3. Intellectual Property</h2>
        <p>
          All intellectual property rights related to the website and its content are owned by us. You may not use, reproduce, or distribute any content from the website without our prior written permission.
        </p>

        <h2>4. User Conduct</h2>
        <p>
          You agree to use the website in compliance with all applicable laws and regulations. You are solely responsible for any content you submit or transmit through the website.
        </p>

        <h2>5. Limitation of Liability</h2>
        <p>
          We shall not be liable for any direct, indirect, incidental, consequential, or punitive damages arising out of your use or inability to use the website.
        </p>

        <h2>6. Governing Law</h2>
        <p>
          These terms of use are governed by and construed in accordance with the laws of your jurisdiction. Any disputes arising out of or in connection with these terms shall be subject to the exclusive jurisdiction of the courts in your jurisdiction.
        </p>

        <h2>7. Modifications</h2>
        <p>
          We reserve the right to modify or update these terms of use at any time. It is your responsibility to review these terms periodically for any changes.
        </p>
      </div>
    </div>
  );
};

export default TermsPage;
